<template>
  <div class="footer">
    <div class="content">
      <div class="logo">
        <img src="https://cdn-static-web.moycp.com/nfyk/image/logo-footer.png" alt="">
      </div>
      <div class="text">
        <span>校址：广州市白云区沙太南路1023号-1063号</span>
        <span class="left-line">咨询电话：020-61649459</span>
        <div>
          <span>京ICP备14049531号</span>
          <span class="left-line" style="margin-right: 20px">经营许可证编号: 京 B2-20182184</span>
          <span class="left-line">
            <i></i>
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502035129" target="_blank" class="color-line">京公网安备 11010502035129号</a>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style lang="less" scoped>
.footer {
  width: 100%;
  height: 90px;
  background: #454140;
  .content {
    width: 1200px;
    height: 90px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .logo {
      width: 215px;
      height: 60px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .text {
      line-height: 1.5;
      span {
        font-size: 14px;
        color: #a19fa0;
        &:nth-child(2) {
          margin-left: 20px;
        }
      }
      .left-line {
        border-left: 1px solid #a19fa0;
        padding-left: 20px;
        i {
          display: inline-block;
          width: 15px;
          height: 15px;
          margin-bottom: -2px;
          background: url('../assets/images/police.png') center no-repeat;
          background-size: contain;
        }
      }
      .color-line {
        color: #a19fa0;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue